import React from 'react';
import agent from '../../../../agent';
import SavedSearchComboChartWidget from './SavedSearchComboChartWidget'
import LoaderWidget from '../Loader/LoaderWidget'
import {checkForUnauthorisedResponse} from '../../../Utils/ErrorHandler'

class SavedSearchComboChartWidgetContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      search: {
        rows:[]
      },
      loaded:false
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    console.log(this.props);
    this.runSearch(this.props.savedSearchId, this.props.bypassCache, this.props.yAxisColumn, this.props.xAxisColumn, this.props.yAxisColumnLine, this.props.savedSearchLineId);
  }

  runSearch(savedSearchId, bypassCache, yAxisColumn, xAxisColumn, yAxisColumnLine, savedSearchLineId) {
    agent.Search.executeComboChartSearch(savedSearchId, bypassCache, yAxisColumn, xAxisColumn, yAxisColumnLine, savedSearchLineId).then(
      res => {
        if(res.result) {
          this.setState({
            ...this.state,
            'search':res.data,
            'loaded':true
          })
        } else {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      },
      error => {
        if(!checkForUnauthorisedResponse(error, agent)) {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      }
    )

  }


  render() {
    if(this.state.loaded) {
      return (
        <SavedSearchComboChartWidget {...this.props} onWidgetRefresh={this.refresh.bind(this)} search={this.state.search} />
      )
    } else {
      return (
        <LoaderWidget {...this.props}/>
      )
    }

  }
}

export default SavedSearchComboChartWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/SavedSearchComboChartWidget/SavedSearchComboChartWidgetContainer.js